import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "outer"
};
const _hoisted_2 = { class: "container" };
const _hoisted_3 = { class: "vehicle-selection-section" };
const _hoisted_4 = { class: "vehicle-types-list" };
const _hoisted_5 = {
    key: 0,
    class: "vehicle-types-list__loading"
};
const _hoisted_6 = {
    key: 1,
    class: "vehicle-types-list__loading"
};
const _hoisted_7 = {
    key: 2,
    class: "vehicle-types-list__error"
};
const _hoisted_8 = {
    key: 3,
    class: "vehicle-types-list__items"
};
import { onMounted, ref, watch } from 'vue';
import { useOilFinder } from '../../composables/useOilFinder';
import { useStep } from '../../composables/useStep';
import { useVehicleTypes } from '../../composables/useVehicleTypes';
import { useVehicleDetails } from '../../composables/useVehicleDetails';
import { useRedirect } from '../../composables/useRedirect';
import { useVehicleComponents } from '../../composables/useVehicleComponents';
import { useMakeModelSearch } from '../../composables/useMakeModelSearch';
import VehicleCard from './VehicleCard.vue';
const VEHICLE_KEY = 'selectedVehicleId';
const LICENCE_PLATE_KEY = 'selectedLicencePlate';
const VISIBLE_COMPONENTS = 'selectedVisibleComponents';
// Handle vehicle selection from the table component
export default /*@__PURE__*/ _defineComponent({
    __name: 'VehicleTypesList',
    setup(__props) {
        const { vehicleTypes, isLoading, error, setLoading } = useVehicleTypes();
        const { selectedMake, selectedModel } = useMakeModelSearch();
        const isAutoSelecting = ref(false);
        const { setVehicleDetails, licencePlate, setLicencePlate } = useVehicleDetails();
        const { setVehicleComponents } = useVehicleComponents();
        const { nextStep } = useStep();
        const { api } = useOilFinder();
        const { shouldRedirectAfterVehicleSelection, redirect } = useRedirect();
        async function handleVehicleSelect(type) {
            await clickVehicleType(type);
        }
        // Handle click on a vehicle type
        async function clickVehicleType(type) {
            // Store vehicle ID and licence plate in localStorage for redirect handling
            localStorage.setItem(VEHICLE_KEY, type.id.toString());
            localStorage.setItem(LICENCE_PLATE_KEY, licencePlate.value || '');
            // Check if we should redirect after vehicle selection
            if (shouldRedirectAfterVehicleSelection()) {
                redirect();
                return;
            }
            // Otherwise, proceed normally
            await processVehicleType(type.id);
        }
        async function processVehicleType(vehicleId) {
            // Show loading state
            setLoading(true);
            const response = await api.getProductRecommendations(vehicleId);
            setVehicleDetails(response.data.vehicle);
            setVehicleComponents(response.data.recommendations);
            setLoading(false);
            removeLocalStorageKeys();
            nextStep();
        }
        // Check localStorage on mount to auto-continue if redirected
        onMounted(async () => {
            const isReturning = localStorage.getItem('isReturningToResults');
            const storedLicencePlate = localStorage.getItem(LICENCE_PLATE_KEY);
            const storedVehicleId = localStorage.getItem(VEHICLE_KEY);
            // Only process if we're returning from a redirect
            if (isReturning) {
                localStorage.removeItem('isReturningToResults');
            }
            if (storedLicencePlate) {
                setLicencePlate(storedLicencePlate.toString());
                localStorage.removeItem(LICENCE_PLATE_KEY);
            }
            if (storedVehicleId) {
                localStorage.removeItem(VEHICLE_KEY);
                await processVehicleType(Number(storedVehicleId));
            }
            // Clean up visible components if it exists
            if (localStorage.getItem(VISIBLE_COMPONENTS)) {
                localStorage.removeItem(VISIBLE_COMPONENTS);
            }
        });
        const removeLocalStorageKeys = () => {
            localStorage.removeItem(VEHICLE_KEY);
            localStorage.removeItem(LICENCE_PLATE_KEY);
        };
        // Auto-select if only one vehicle type is returned
        watch([vehicleTypes, isLoading], (values) => {
            const [types, loading] = values;
            if (!loading && types.length === 1) {
                // Show loading state before auto-selecting
                isAutoSelecting.value = true;
                // Small delay so user sees the transition message
                setTimeout(() => {
                    // Automatically proceed with the single vehicle option
                    clickVehicleType(types[0]);
                }, 2000);
            }
        }, { immediate: true });
        return (_ctx, _cache) => {
            return ((_unref(vehicleTypes).length > 0 || _unref(isLoading) || _unref(error)) && _unref(licencePlate))
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _cache[2] || (_cache[2] = _createElementVNode("h1", { class: "page-title" }, "Select your model", -1)),
                            _createElementVNode("div", _hoisted_4, [
                                (_unref(isLoading))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[0] || (_cache[0] = [
                                            _createElementVNode("div", { class: "loading-spinner" }, null, -1),
                                            _createElementVNode("span", null, "Loading...", -1)
                                        ]))]))
                                    : (isAutoSelecting.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[1] || (_cache[1] = [
                                                _createElementVNode("div", { class: "loading-spinner" }, null, -1),
                                                _createElementVNode("span", null, "Found your vehicle, loading recommendations...", -1)
                                            ]))]))
                                        : (_unref(error))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(error)), 1))
                                            : (_unref(vehicleTypes).length > 0 && _unref(licencePlate))
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(vehicleTypes), (type) => {
                                                        return (_openBlock(), _createBlock(VehicleCard, {
                                                            key: type.id,
                                                            type: type,
                                                            "selected-make": _unref(selectedMake),
                                                            "selected-model": _unref(selectedModel),
                                                            "compact-view": false,
                                                            onSelect: handleVehicleSelect
                                                        }, null, 8, ["type", "selected-make", "selected-model"]));
                                                    }), 128))
                                                ]))
                                                : _createCommentVNode("", true)
                            ])
                        ])
                    ])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
